<template>
  <div>
    <end-confirm
      confirmText="Are you sure want to end DOTS ?"
      :dialog="dialog"
      @confirmed="confirmed"
      @cancel="dialog = false"
    />
    <v-row v-if="data.dots_enddate == null">
      <v-col lg="10" offset-lg="1" v-if="data.dots_app_status == 2">
        <v-card class="card--shadow">
          <v-card-title>End DOTS Activity</v-card-title>
          <v-card-text>
            <v-row>
              <v-col lg="5">
                <v-menu
                  ref="dateMenu"
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      placeholder="choose date"
                      prepend-inner-icon="mdi-calendar"
                      outlined
                      dense
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      v-model="date"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    no-title
                    @input="dateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col lg="4">
                <v-btn @click="submitForm" depressed dark class="mb-1 form-btn"
                  >Submit</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col lg="10" offset-lg="1" v-if="data.dots_app_status == 2">
        <v-card class="card--shadow">
          <v-card-title>
            <h3>
              Your DOTS Activity has been stopped on {{ data.dots_enddate }}
            </h3>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EndConfirm from "../modal/EndConfirm.vue";
export default {
  components: { EndConfirm },
  data: () => ({
    dateMenu: null,
    date: "",
    dialog: false,
  }),
  methods: {
    submitForm() {
      if (this.date) {
        if (new Date(this.date) < new Date(this.data.dots_startdate)) {
          this.$toast.error(
            "DOTS Finished Date should be larger thant DOTS Startdate"
          );
        } else {
          this.dialog = true;
        }
      }
    },
    confirmed() {
      this.$store.dispatch("DotsPatient/finishDOTS", {
        dots_patient_id: this.$route.params.id,
        date: this.date,
      });

      this.dialog = !this.dialog;
    },
  },
  created() {
    this.$store.dispatch("Loading/changeLocalLoading");

    this.$store
      .dispatch("DotsPatient/getEach", {
        column: "id",
        value: this.$route.params.id,
      })
      .then(() => {
        this.$store.dispatch("Loading/changeLocalLoading");
      });
  },
  computed: {
    ...mapState("DotsPatient", ["data"]),
  },
};
</script>

<style></style>
